import { useState } from "react";

import { Button } from "@components/Button";
import { Drawer } from "@components/Drawer";
import { Hairline } from "@components/Hairline";
import { Input } from "@components/Input";
import { Label } from "@components/Label";
import { Loading } from "@components/Loading";
import { Radio } from "@components/Radio";

import style from "@styles/pages/oraculo/oraculo.module.scss";

import { SuccessIcon } from "@components/Icons";
import { If } from "@components/control-statements";
import OcdpAPI from "@providers/OcdpAPI";
import OcdpAPI2 from "providers/OcdpAPI2";
import { Cdp } from "shared/core/cdp";

const AudienceType = {
  STATIC: "STATIC",
  DYNAMIC: "DYNAMIC",
};

const clone = (obj) => JSON.parse(JSON.stringify(obj));

export default function SaveAudience({
  visible,
  version,
  audience = null,
  state,
  onSave,
  onClose,
}) {
  const [finishedSave, setFinishedSave] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(audience?.name || "");
  const [audience_type, setAudienceType] = useState(
    audience?.type || AudienceType.STATIC
  );

  const save_fn = async () => {
    try {
      
      const ocdp_api = version == 'v2' ? new OcdpAPI2() : new OcdpAPI();
      setLoading(true);

      const _state = clone(state || {});
      const response = await ocdp_api.upsert_audience(audience?.id, {
        ...(_state || {}),
        type: audience_type,
        name: name,
      });

      if (!response?.execution_id) {
        throw new Error("Ocorreu um erro ao salvar o público");
      }

      const exec = await Cdp.waitQueryExecution(response?.execution_id);
      if (exec?.status == "ERROR") {
        throw new Error("Ocorreu um erro ao salvar o público");
      }

      setLoading(false);
      setFinishedSave(true);
      return response;
    } catch (err) {
      alert({ text: err.message });
      setLoading(false);
    }
    return false;
  };

  const save_hub = async () => {
    const response = await save_fn();
    if (!response) {
      return false;
    }

    const ocdp_api = version == 'v2' ? new OcdpAPI2() : new OcdpAPI();
    const audience = await ocdp_api.audience(response?.audience_id);
    const { sort, limit } = audience?.extras || {};
    onSave && onSave({ ...audience, sort, limit });
    setName("");
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => {
        onClose();
        setFinishedSave(false);
        setName("");
      }}
      title="Salvar	público"
      subtitle={finishedSave && "Você já pode visualizar o seu público"}
      showCloseButton
    >
      <If cond={!loading}>
        <If cond={!finishedSave}>
          <Label>Dê um nome ao seu público:</Label>
          <Input
            placeholder="Nome do público"
            value={name}
            onChange={(text) => setName(text.target.value)}
          />
          <Hairline className="mt-30 mb-30" />
          <Label>Defina o tipo do público:</Label>
          <div className="d-flex align-center justify-between mb-10">
            <Radio
              family="audienceType"
              value={AudienceType.STATIC}
              checked={audience_type}
              onChange={() => setAudienceType(AudienceType.STATIC)}
            >
              Estático
            </Radio>
            <span className={style.tag}>FOTOGRAFIA DE AGORA</span>
          </div>
          <div className="d-flex align-center justify-between">
            <Radio
              family="audienceType"
              value={AudienceType.DYNAMIC}
              checked={audience_type}
              onChange={() => setAudienceType(AudienceType.DYNAMIC)}
            >
              Dinâmico
            </Radio>
            <span className={style.tag}>RECALCULADO DIARIAMENTE</span>
          </div>
        </If>

        <If cond={finishedSave}>
          <div className={style.successContainer}>
            <div className={style.successIcon}>
              <SuccessIcon />
            </div>
          </div>
        </If>

        <If cond={!loading}>
          <div className={style.footer} onClick={save_hub}>
            <If cond={!finishedSave}>
              <Button
                className="w-100"
                disabled={name.length < 3}
                onClick={save_hub}
                design="primary"
              >
                Salvar
              </Button>
            </If>
            <If cond={finishedSave}>
              <Button
                design="primary"
                className="w-100"
                text="Concluir"
                onClick={() => {
                  onClose();
                  setFinishedSave(false);
                }}
              />
            </If>
          </div>
        </If>
      </If>

      <If cond={loading}>
        <div className={style.loading}>
          <Loading />
        </div>
      </If>
    </Drawer>
  );
}
